export default __webpack_public_path__ + "static/media/hard-dificulty.a945d9db.svg";